
interface BroCodeDisplayProps {
  brocode: string;
  twitterHandle?: string;
}

const BroCodeDisplay = ({ brocode, twitterHandle }: BroCodeDisplayProps) => {
  return (
    <div className="mt-8 space-y-4 flex justify-center">
      <div className="bg-navy-dark text-tan p-4 rounded-lg border border-tan-dark inline-block shadow-lg">
        <p className="text-lg font-bold">Your BroCode: {brocode}</p>
        {twitterHandle && (
          <p className="text-sm text-tan-dark mt-1">Twitter: @{twitterHandle}</p>
        )}
        <p className="text-sm mt-2">Share this code with the BroMENtum Telegram bot to verify your rank.</p>
      </div>
    </div>
  );
};

export default BroCodeDisplay;
